var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CampaignBudgetFormModel, TemporaryCampaignBudgetFormModel, getCampaignBudgets, factoryCampaignBudget, CreativeSchduleCreativeFormModel, AdvancedSettingFormModel, factoryMenuSettingForm, } from '.';
import Defaults from '../Defaults';
import { CreativeAttachTargets, GoalTypes } from '../Constants';
import { MenuTypes } from '@/models/Menu/Constants';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import dayjs from 'dayjs';
var defaults = Defaults.Campaign;
var CampaignFormModel = /** @class */ (function () {
    function CampaignFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, name = _a.name, menuId = _a.menuId, _b = _a.menuType, menuType = _b === void 0 ? MenuTypes.Geo : _b, code = _a.code, _c = _a.creativeType, creativeType = _c === void 0 ? null : _c, _d = _a.creativeAttachTarget, creativeAttachTarget = _d === void 0 ? CreativeAttachTargets.CAMPAIGN : _d, _e = _a.creatives, creatives = _e === void 0 ? [] : _e, _f = _a.enablePacingPerBudget, enablePacingPerBudget = _f === void 0 ? defaults.enablePacingPerBudget : _f, _g = _a.pacingType, pacingType = _g === void 0 ? defaults.pacingType : _g, _h = _a.dailyLimitBudget, dailyLimitBudget = _h === void 0 ? defaults.dailyLimitBudget : _h, _j = _a.evenPacePercentage, evenPacePercentage = _j === void 0 ? defaults.evenPacePercentage : _j, _k = _a.campaignBudgets, campaignBudgets = _k === void 0 ? [] : _k, _l = _a.temporaryCampaignBudgets, temporaryCampaignBudgets = _l === void 0 ? [] : _l, _m = _a.useAdvancedSetting, useAdvancedSetting = _m === void 0 ? defaults.useAdvancedSetting : _m, _o = _a.goalType, goalType = _o === void 0 ? defaults.goalType : _o, _p = _a.goalCpc, goalCpc = _p === void 0 ? defaults.goalCpc : _p, _q = _a.enableOptimization, enableOptimization = _q === void 0 ? defaults.enableOptimization : _q, status = _a.status, _r = _a.useCreativeSchedule, useCreativeSchedule = _r === void 0 ? defaults.useCreativeSchedule : _r, menuSetting = _a.menuSetting, _s = _a.advancedSetting, advancedSetting = _s === void 0 ? {} : _s, _t = _a.isFromSimulation, isFromSimulation = _t === void 0 ? false : _t, _u = _a.profileIds, profileIds = _u === void 0 ? {} : _u;
        this.id = id;
        this.name = name;
        this.menuId = menuId;
        this.code = code;
        this.creativeType = creativeType;
        this.creativeAttachTarget = creativeAttachTarget;
        this.creatives = creatives.map(CreativeSchduleCreativeFormModel.assign);
        this.enablePacingPerBudget = enablePacingPerBudget;
        this.pacingType = pacingType;
        this.dailyLimitBudget = dailyLimitBudget;
        this.evenPacePercentage = evenPacePercentage;
        this.campaignBudgets = campaignBudgets.map(CampaignBudgetFormModel.assign);
        this.temporaryCampaignBudgets = temporaryCampaignBudgets.map(TemporaryCampaignBudgetFormModel.assign);
        this.useAdvancedSetting = useAdvancedSetting;
        this.originalUseAdvancedSetting = cloneDeep(this.useAdvancedSetting);
        this.goalType = goalType;
        this.goalCpc = goalCpc;
        this.enableOptimization = enableOptimization;
        this.status = status;
        this.useCreativeSchedule = useCreativeSchedule;
        this.isFromSimulation = isFromSimulation;
        this.menuSetting = factoryMenuSettingForm(profileIds, menuType, menuSetting);
        this.originalMenuSetting = cloneDeep(this.menuSetting);
        var _v = advancedSetting, _w = _v.deliveryDevices, deliveryDevices = _w === void 0 ? [] : _w, _x = _v.deliveryInventories, deliveryInventories = _x === void 0 ? [] : _x, _y = _v.inventoryListOptionalIds, inventoryListOptionalIds = _y === void 0 ? [] : _y, _z = _v.onlyJapaneseDevice, onlyJapaneseDevice = _z === void 0 ? defaults.onlyJapaneseDevice : _z, weeklyDeliverySchedule = _v.weeklyDeliverySchedule, demographicSetting = _v.demographicSetting, ipAreaSetting = _v.ipAreaSetting;
        this.advancedSetting = new AdvancedSettingFormModel({
            deliveryDevices: deliveryDevices,
            deliveryInventories: deliveryInventories,
            inventoryListOptionalIds: inventoryListOptionalIds,
            onlyJapaneseDevice: onlyJapaneseDevice,
            weeklyDeliverySchedule: weeklyDeliverySchedule,
            demographicSetting: demographicSetting,
            ipAreaSetting: ipAreaSetting,
            menuType: menuType,
        });
        this.originalAdvancedSetting = cloneDeep(this.advancedSetting);
    }
    CampaignFormModel.prototype.setAdvancedSetting = function () {
        var _a;
        this.advancedSetting = new AdvancedSettingFormModel(__assign(__assign({}, this.advancedSetting), { menuType: (_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuType }));
    };
    CampaignFormModel.prototype.setMenuSetting = function (profileIds) {
        if (!this.menu || !this.menu.menuType)
            return;
        this.menuSetting = factoryMenuSettingForm(profileIds, this.menu.menuType);
    };
    Object.defineProperty(CampaignFormModel.prototype, "isNew", {
        get: function () {
            return this.id == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "isCampaignCreative", {
        get: function () {
            return this.creativeAttachTarget === CreativeAttachTargets.CAMPAIGN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "mergedCampaignBudgets", {
        get: function () {
            return this.campaignBudgets.concat(this.temporaryCampaignBudgets);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "zeroGoalCpcViolation", {
        get: function () {
            var _a;
            return (((_a = this.menu) === null || _a === void 0 ? void 0 : _a.unitType) !== 'cpc' &&
                this.enableOptimization &&
                this.goalCpc <= 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "isSimulatable", {
        get: function () {
            return (!this.isMenuEmpty &&
                !this.advancedSetting.isDeviceEmpty &&
                !this.advancedSetting.isInventoryEmpty &&
                !this.isCreativeTypeEmpty &&
                !this.advancedSetting.isIncorrectInventoryCombinationWithPC &&
                !this.advancedSetting.isIncorrectInventoryCombinationWithMobile &&
                !this.advancedSetting.isIncorrectDeviceCombinationWithMobileInventory &&
                this.menuSetting.isSimulatable);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "isMenuEmpty", {
        get: function () {
            return !this.menuId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "isCreativeTypeEmpty", {
        get: function () {
            return !this.creativeType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "mergedCampaignBudgetsCopy", {
        get: function () {
            return this.mergedCampaignBudgets.map(function (cb) {
                // eslint-disable-next-line no-prototype-builtins
                if (CampaignBudgetFormModel.prototype.isPrototypeOf(cb)) {
                    return CampaignBudgetFormModel.assign(cb);
                }
                else {
                    return TemporaryCampaignBudgetFormModel.assign(cb);
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "campaignBudgetsCreatives", {
        get: function () {
            return this.mergedCampaignBudgets
                .map(function (cb) {
                return cb.creativeSchedules
                    .map(function (cs) { return cs.creatives; })
                    .flat();
            })
                .flat();
        },
        enumerable: false,
        configurable: true
    });
    CampaignFormModel.prototype.selectMenu = function (menu) {
        this.menu = menu;
        if (menu.unitType === 'cpc') {
            this.goalType = menu.unitType;
            this.goalCpc = menu.grossPrice;
            this.enableOptimization = true;
        }
        else if (menu.unitType === 'cpcv') {
            this.enableOptimization = false;
        }
        else {
            this.goalType = defaults.goalType;
            this.goalCpc = defaults.goalCpc;
            this.enableOptimization = defaults.enableOptimization;
        }
    };
    CampaignFormModel.prototype.addCampaignBudget = function (insertionOrderBudget, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.budget, budget = _c === void 0 ? 0 : _c;
        var campaignBudget = factoryCampaignBudget(insertionOrderBudget, getCampaignBudgets(this.mergedCampaignBudgets, insertionOrderBudget), { budget: budget });
        if (!campaignBudget)
            return;
        if (campaignBudget instanceof CampaignBudgetFormModel) {
            this.campaignBudgets.push(campaignBudget);
        }
        else if (campaignBudget instanceof TemporaryCampaignBudgetFormModel) {
            this.temporaryCampaignBudgets.push(campaignBudget);
        }
    };
    CampaignFormModel.prototype.deleteCampaignBudget = function (campaignBudget) {
        if (campaignBudget.isNew) {
            if (campaignBudget instanceof CampaignBudgetFormModel) {
                var index = this.campaignBudgets.findIndex(function (b) { return b.tempId === campaignBudget.tempId; });
                index >= 0 && this.campaignBudgets.splice(index, 1);
            }
            else {
                var index = this.temporaryCampaignBudgets.findIndex(function (b) { return b.tempId === campaignBudget.tempId; });
                index >= 0 && this.temporaryCampaignBudgets.splice(index, 1);
            }
        }
        else {
            campaignBudget.delete();
        }
    };
    /**
     * enableOptimization を変更する。
     * On にする際、 goalType が none の場合のみ、 cpc を指定し直す。
     *
     * @param {boolean} bool
     */
    CampaignFormModel.prototype.updateEnableOptimization = function (bool) {
        if (bool) {
            if (this.goalType === GoalTypes.NONE) {
                this.goalType = GoalTypes.CPC;
            }
        }
        this.enableOptimization = bool;
    };
    CampaignFormModel.prototype.resetCreativeSchedule = function () {
        this.campaignBudgets.map(function (cb) { return cb.resetCreativeSchedules(); });
        this.temporaryCampaignBudgets.map(function (cb) { return cb.resetCreativeSchedules(); });
    };
    CampaignFormModel.prototype.isCreativeScheduleViolation = function (copyBudgets) {
        return (this.useCreativeSchedule &&
            this.makeBudgetTimesJson(this.mergedCampaignBudgets) !==
                this.makeBudgetTimesJson(copyBudgets));
    };
    CampaignFormModel.prototype.makeBudgetTimesJson = function (budget) {
        return JSON.stringify(budget.map(function (cb) {
            return { startTime: cb.startTime, endTime: cb.endTime };
        }));
    };
    CampaignFormModel.prototype.removeCreatives = function () {
        this.creatives = [];
    };
    Object.defineProperty(CampaignFormModel.prototype, "hasCreative", {
        /**
         * 1つでもクリエイティブと紐づいているかどうか
         */
        get: function () {
            return this.allCreativesCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "allCreativesCount", {
        get: function () {
            var campaignCreativeCount = this.creatives.length;
            var scheduleCreativeCount = this.campaignBudgetsCreatives
                .map(function (cbc) { return cbc.creatives; })
                .flat().length;
            return campaignCreativeCount + scheduleCreativeCount;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * クリエイティブ種別を変更する。
     * 変更と同時に紐づいているクリエイティブを全て解除する。
     */
    CampaignFormModel.prototype.changeCreativeType = function (creativeType) {
        if (this.creativeType === creativeType)
            return;
        this.creativeType = creativeType;
    };
    Object.defineProperty(CampaignFormModel.prototype, "hasGeoMenuSetting", {
        get: function () {
            var _a;
            return ((_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuType) === MenuTypes.Geo;
        },
        enumerable: false,
        configurable: true
    });
    CampaignFormModel.prototype.fetchCreativeSchedules = function () {
        this.mergedCampaignBudgets.map(function (cb) {
            return cb.creativeSchedules.map(function (cs) {
                return cs.fetchCreatives();
            });
        });
    };
    Object.defineProperty(CampaignFormModel.prototype, "isCampaignCreativeSchedule", {
        get: function () {
            return this.useCreativeSchedule && this.isCampaignCreative;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "hasRailwayMenuSetting", {
        get: function () {
            var _a;
            return ((_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuType) === MenuTypes.Railway;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "hasCustomGeoMenuSetting", {
        get: function () {
            var _a;
            return ((_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuType) === MenuTypes.CustomGeo;
        },
        enumerable: false,
        configurable: true
    });
    CampaignFormModel.prototype.initMenuSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.menuSetting.init()];
                    case 1:
                        _a.sent();
                        this.originalMenuSetting = cloneDeep(this.menuSetting);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CampaignFormModel.prototype, "isChanged", {
        get: function () {
            if (!isEqual(this.originalMenuSetting, this.menuSetting))
                return true;
            if (this.originalUseAdvancedSetting === this.useAdvancedSetting) {
                return this.advancedSetting.isChanged;
            }
            if (this.originalUseAdvancedSetting) {
                return this.originalAdvancedSetting.demographicSetting.isSelected;
            }
            if (this.useAdvancedSetting) {
                return this.advancedSetting.demographicSetting.isSelected;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CampaignFormModel.prototype, "expiredCampaignBudgets", {
        get: function () {
            return this.campaignBudgets.filter(function (budget) {
                return budget.updatedTime &&
                    dayjs().isAfter(dayjs(budget.endTime).subtract(3, 'm'));
            });
        },
        enumerable: false,
        configurable: true
    });
    return CampaignFormModel;
}());
export { CampaignFormModel };
